import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Spin } from 'antd';

import { LoadingBar, TableForm, Pagination } from 'components/Commons';

import cm from 'helpers/commons';

class ExcelList extends Component {
  render() {
    // const { list } = this.props,
    const { list, page, pagerow, loading, pageClick, excelDownload, isLoading } = this.props.excelFn;
    let loadingForm = '';
    let p_page = page;
    let p_pagerow = pagerow;
    let p_totalcount = 0;
    let tabledata = {
      header: {
        main: [
          { data: '#', textAlign: 'left' },
          { data: 'ID', textAlign: 'left' },
          { data: '이름', textAlign: 'left' },
          { data: '요청시각', textAlign: 'left' },
          { data: '파일명', textAlign: 'left' },
          { data: '요청자료', textAlign: 'left' },
          { data: '권한', textAlign: 'left' },
          { data: '다운로드 수', textAlign: 'right' },
          {}
        ]
      },
      body: {
        message: '엑셀 다운로드 내역이 존재하지 않습니다.',
        main: null
      }
    };

    if (!loading) {
      if (list && list.data) {
        const { paging, excel } = list.data;

        if (paging) {
          p_page = paging.page;
          p_pagerow = paging.pagerow;
          p_totalcount = paging.totalcount;
        }

        if (excel && excel.length > 0) {
          tabledata.body.main = excel.map((item) => {
            let authority = '-';
            switch (item.user.level) {
              case -5:
                authority = '탈퇴 예정';
                break;
              case -1:
                authority = '일시정지';
                break;
              case 0:
                authority = '탈퇴';
                break;
              case 1:
                authority = '일반사용자';
                break;
              case 30:
                authority = '회사관리자';
                break;
              case 99:
                authority = '전체관리자';
                break;
              default:
                break;
            }

            const isGenerating = item.excelStatus === 'GENERATING';
            const background = item.excelStatus === 'GENERATING' ? 'rgb(0 0 0 / 15%)' : '';
            let obj = {
              row: [
                {
                  data: item.idx,
                  textAlign: 'left',
                  fontWeight: 'bold',
                  background
                },
                {
                  data: item.user.signid,
                  textAlign: 'left',
                  background
                },
                {
                  data: item.user.name,
                  textAlign: 'left',
                  background
                },
                {
                  data: cm.yyyyMMdd(new Date(item.request.date)) + ' ' + cm.hhmmss(new Date(item.request.date)),
                  textAlign: 'left',
                  background
                },
                {
                  data: isGenerating ? (
                    <div>
                      파일 생성중입니다... <Spin />
                    </div>
                  ) : (
                    item.file.name
                  ),
                  textAlign: 'left',
                  background
                },
                {
                  data: item.request.text,
                  textAlign: 'left',
                  background
                },
                {
                  data: item.user.presetName,
                  textAlign: 'left',
                  background
                },
                {
                  data: cm.numberComma(item.downcount),
                  textAlign: 'right',
                  background
                },
                {
                  data: '다운로드',
                  btnFunc: excelDownload,
                  btnData: { id: item.file.id, name: item.file.name },
                  btnProps: { loading: isLoading, disabled: isLoading || isGenerating },
                  background
                }
              ]
            };
            return obj;
          });
        }
      } else {
        if (list.response) {
          tabledata.body.message = list.response.data.message;
        }
      }
    } else {
      loadingForm = <LoadingBar />;
    }

    return (
      <div>
        {loadingForm}

        <div className="table-box">
          <TableForm tabledata={tabledata} />
        </div>

        <div className="table-paging">
          <Pagination
            page={p_page}
            pageRow={p_pagerow}
            pageBlock={10}
            totalCount={p_totalcount}
            pageClick={pageClick}
          />
        </div>
      </div>
    );
  }
}

ExcelList = connect((state) => ({
  list: state.etc.list,
  download: state.etc.download
}))(ExcelList);

export default ExcelList;
